import { render } from "./ReferenciaDet.vue?vue&type=template&id=33c85177&scoped=true"
import script from "./ReferenciaDet.vue?vue&type=script&lang=js"
export * from "./ReferenciaDet.vue?vue&type=script&lang=js"

import "@/assets/css/listaFiltrada02.css?vue&type=style&index=0&id=33c85177&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c85177"]])

export default __exports__